import { createRouter, createWebHistory } from "vue-router";
import jwt_decode                         from 'jwt-decode';
import store                              from '@/store'
import Login                              from "@/views/Login";
import Index                              from "@/views/Index"
import Painel                             from "@/components/Painel"
import Usuario                            from "@/components/Usuario"
import Questionario                       from "@/components/Questionario"
import Prova                              from "@/components/Prova"
import Nota                               from "@/components/Nota"
import TBLDashboardIndividual             from "@/components/TBLDashboardIndividual.vue"
import Repositorio                        from "@/components/Repositorio"
import Aluno                              from "@/components/Aluno"
import AlunoNota                          from "@/components/AlunoNota"
import AlunoDashboard                     from "@/components/AlunoDashboard.vue"
import AvaliacaoDiscursiva                from "@/components/AvaliacaoDiscursiva"
import OSCE                               from "@/components/OSCE"
import AdminSistema                       from "@/components/AdminSistema.vue"
import Materiais                          from "@/components/Materiais.vue"
import Assistente                         from "@/components/Assistente.vue"
import isTokenExpired                     from '@/assets/js/common/isTokenExpired';

const routes = [

  {
    path: "/",
    redirect: '/Painel',
    name: "index",
    component: Index,
    children: [
      {
        path: "/Painel",
        name: "painel",
        component: Painel,
        meta: { pageTitle: "Painel | Trackly" },
      },
      {
        path: "/Usuario/:uPage",
        name: "usuario",
        component: Usuario,
        meta: { pageTitle: "Pessoal | Trackly" },
      },
      {
        path: "/Questionario/:qPage",
        name: "criarQuestionario",
        component: Questionario,
        meta: { pageTitle: "Criar Question\u00e1rio | Trackly" },
      },
      {
        path: "/Questionario/:qPage/:idQuestion",
        name: "editarQuestionario",
        component: Questionario,
        meta: { pageTitle: "Editar Question\u00e1rio | Trackly" },
      },
      {
        path: "/Questionarios/:qPage",
        name: "questionarios",
        component: Questionario,
        meta: { pageTitle: "Meus Question\u00e1rios | Trackly" },
      },
      {
        path: "/Prova/:pPage",
        name: "prova",
        component: Prova,
        meta: { pageTitle: "Aplicar Atividade Avaliativa | Trackly" },
      },
      {
        path: "/Prova/:pPage/:id",
        name: "provaId",
        component: Prova,
        meta: { pageTitle: "Atividade Avaliativa | Trackly" },
      },
      {
        path: "/Provas/DashboardIndividual",
        name: "tblDashboardIndividual",
        component: TBLDashboardIndividual,
        meta: { pageTitle: "Dashboard Individual | Trackly" },
      },
      {
        path: "/Provas/:psPage",
        name: "provas",
        component: Nota,
        meta: { pageTitle: "Atividades Avaliativas | Trackly" },
      },
      {
        path: "/Provas/:psPage/:id",
        name: "notas",
        component: Nota,
        meta: { pageTitle: "Resultado da Atividade Avaliativa | Trackly" },
      },
      {
        path: "/Repositorios/:rPage",
        name: "repositorios",
        component: Repositorio,
        meta: { pageTitle: "Reposit\u00f3rios | Trackly" },
      },
      {
        path: "/Aluno/:aPage",
        name: "alunoSalaAula",
        component: Aluno,
        meta: { pageTitle: "Trackly" },
      },
      {
        path: "/Aluno/:aPage/:id",
        name: "alunoProva",
        component: Aluno,
        meta: { pageTitle: "Atividade Avaliativa | Trackly" },
      },
      {
        path: "/aProvas/:anPage",
        name: "alunoProvas",
        component: AlunoNota,
        meta: { pageTitle: "Atividades Avaliativas | Trackly" },
      },
      {
        path: "/aProvas/:anPage/:id",
        name: "alunoNotas",
        component: AlunoNota,
        meta: { pageTitle: "Resultado da Atividade Avaliativa | Trackly" },
      },
      {
        path: "/Aluno/Dashboard",
        name: "alunoDashboard",
        component: AlunoDashboard,
        meta: { pageTitle: "Dashboard Acad\u00eamico | Trackly" },
      },
      {
        path: "/AvaliacaoDiscursiva/:dPage/:subPage?",
        name: "avaliacaoDiscursiva",
        component: AvaliacaoDiscursiva,
        meta: { pageTitle: "Avalia\u00e7\u00e3o Discursiva | Trackly" },
      },
      {
        path: "/OSCE/:oPage?",
        name: "osce",
        component: OSCE,
        meta: { pageTitle: "OSCE | Trackly" },
      },
      {
        path: "/Materiais",
        name: "materiais",
        component: Materiais,
        meta: { pageTitle: "Materiais | Trackly" },
      },
      {
        path: "/Assistente",
        name: "assistente",
        component: Assistente,
        meta: { pageTitle: "Assistente | Trackly" },
      },
      {
        path: "/AdminSistema",
        name: "adminSistema",
        component: AdminSistema,
        meta: { pageTitle: "Administração | Trackly" },
      },
    ],
  },

  {
    path: "/Login",
    name: "login",
    component: Login,
    meta: { pageTitle: "Login | Trackly" },
  },
  {
    path: "/Login/:token/:id",
    name: "recuperaSenha",
    component: Login,
    meta: { pageTitle: "Login | Trackly" },
    //meta: { pageTitle: "Recupera\u00e7\u00e3o de Senha | Trackly" },
  },

  /*{
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" *//* "../views/AboutView.vue"),
},*/

];

const profPages    = ['questionarios', 'criarQuestionario', 'editarQuestionario', 'prova', 'provaId', 'provas', 'notas', 'repositorios', 'tblDashboardIndividual'];
const coordBlockedPages = ['questionarios', 'criarQuestionario', 'editarQuestionario', 'prova', 'provaId', 'repositorios'];
const systemAdminPages = ['adminSistema'];
const studentPages = ['alunoSalaAula', 'alunoProva', 'alunoProvas', 'alunoNotas'];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, _from, next) => {
  let token     = localStorage.getItem('token')
  let isExpired = isTokenExpired(token);

  if (token && !isExpired) {
    let decoded = jwt_decode(token);

    store.commit('changeUserId', decoded.user_id);
    store.commit('changeUserType', decoded.user_type);
    store.commit('changeUserName', decoded.user_name);
    store.commit('changeUserRa', decoded.user_ra || '');
    store.commit('changeUserUsername', decoded.user_username || decoded.username || decoded.user_name);
    store.commit('changeUserSex', decoded.user_sex);
  }

  if ((to.name !== 'login' && to.name !== 'recuperaSenha') && (!token || isExpired)) {next({ name: 'login' })}
  else if ((studentPages.some(el => to.name.includes(el))) && ['professor', 'coordenador', 'admin'].includes(store.state.userType)) {next({ name: 'painel' })}
  else if ((profPages.some(el => to.name.includes(el))) && store.state.userType === 'aluno') {next({ name: 'painel' })}
  else if (coordBlockedPages.includes(to.name) && store.state.userType === 'coordenador') {next({ name: 'painel' })}
  else if ((systemAdminPages.some(el => to.name.includes(el))) && !['administrador_sistema', 'admin'].includes(store.state.userType)) {next({ name: 'painel' })}
  else {
    window.document.title =
      to.meta && to.meta.pageTitle
        ? to.meta.pageTitle
        : "Trackly";
    next();
  }
});

export default router;

